<nav role="navigation" class="sidenav">
  <button
    class="button-item"
    mat-menu-item
    (click)="selectMenuItem('home')"
    [ngClass]="{ selected: selectedMenuItem === 'home' }">
    <mat-icon class="icon-item material-icons material-icons--rounded" aria-labelledby="nav-home"
    >home
    </mat-icon>
    @if (isSidenavOpen) {
      <span id="nav-home" class="title-item">{{
          'sidenav.home' | transloco
        }}</span>
    }
  </button>
  <div class="separator"></div>
  <div class="container-separator-title">
    @if (isSidenavOpen) {
      <div class="separator-title">
        {{ 'sidenav.orders' | transloco }}
      </div>
    }
  </div>
  @if (moduleService.isModuleEnabled(Modules.Hotel)) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('hotel')"
      [ngClass]="{ selected: selectedMenuItem === 'hotel' }">
      <mat-icon class="icon-item" fontIcon="hotel" aria-hidden="false"></mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-hotel" class="title-item">{{
            'sidenav.hotel' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.PickupsHotel) && hasPickupsHotelScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('pickups-hotel')"
      [ngClass]="{ selected: selectedMenuItem === 'pickups-hotel' }">
      <mat-icon
        class="icon-item"
        aria-labelledby="nav-pickups-hotel"
        svgIcon="pickups-hotel"></mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-pickups-hotel" class="title-item">{{
            'sidenav.hotelsPickup' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.MepPlane)) {
    <button
      [disabled]="true"
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('mepPlane')"
      [ngClass]="{ selected: selectedMenuItem === 'mepPlane' }">
      <mat-icon class="icon-item" aria-labelledby="nav-mep-plane">airplane_mode</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-mep-plane" class="title-item">{{
            'sidenav.mepPlane' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.Shuttle) && hasShuttlesScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('shuttle')"
      [ngClass]="{ selected: selectedMenuItem === 'shuttle' }">
      <mat-icon class="icon-item" aria-labelledby="nav-runway-airport-shuttle"
      >airport_shuttle
      </mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-runway-airport-shuttle" class="title-item">{{
            'sidenav.runwayAndAirportShuttle' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.TaxiAndPickup) && hasTaxisScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('taxi-and-pickup')"
      [ngClass]="{ selected: selectedMenuItem === 'taxi-and-pickup' }">
      <mat-icon class="icon-item" aria-labelledby="nav-cab-pickup">local_taxi</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-cab-pickup" class="title-item">{{
            'sidenav.cabAndPickup' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.CarRental) && hasCarRentalScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('car-rental')"
      [ngClass]="{ selected: selectedMenuItem === 'car-rental' }">
      <mat-icon class="icon-item" fontIcon="key" aria-hidden="true"></mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-rental-car-vds" class="title-item">{{
            'sidenav.rentalCar' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.Train)) {
    <button
      [disabled]="true"
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('train')"
      [ngClass]="{ selected: selectedMenuItem === 'train' }">
      <mat-icon
        matBadge="1"
        matBadgeColor="warn"
        class="icon-item"
        fontIcon="train"
        aria-hidden="false">
        <span class="sr-only">
          {{ 'sidenav.aria-notifications' | transloco: {nbNotif: 1} }}
        </span>
      </mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-train" class="title-item">{{
            'sidenav.train' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.MealTray) && hasPeqScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('meal-tray')"
      [ngClass]="{ selected: selectedMenuItem === 'meal-tray' }">
      <mat-icon class="icon-item" aria-labelledby="nav-meal">restaurant_menu</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-meal" class="title-item">{{
            'sidenav.meal' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.Compensation) && hasMealCompensationScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('compensation')"
      [ngClass]="{ selected: selectedMenuItem === 'compensation' }">
      <mat-icon class="icon-item" aria-labelledby="nav-compensation">euro_symbol</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-compensation" class="title-item">{{
            'sidenav.compensation' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.LogisticPoint) && hasLogisticPointsScope) {
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('logistic-point')"
      [ngClass]="{ selected: selectedMenuItem === 'logistic-points' }">
      <mat-icon class="icon-item" aria-labelledby="nav-logistic-point">restart_alt</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-logistic-point" class="title-item">{{
            'sidenav.logisticPoints' | transloco
          }}</span>
      }
    </button>
  }
  @if (moduleService.isModuleEnabled(Modules.Settings) && hasParametersScope) {
    <div class="separator"></div>
    <button
      class="button-item"
      mat-menu-item
      (click)="selectMenuItem('settings')"
      [ngClass]="{ selected: selectedMenuItem === 'settings' }">
      <mat-icon class="icon-item" aria-labelledby="nav-settings">settings</mat-icon>
      @if (isSidenavOpen) {
        <span id="nav-settings" class="title-item">{{
            'sidenav.settings' | transloco
          }}</span>
      }
    </button>
  }
</nav>
